export interface AsyncActionLock {
    readonly isInFlight: boolean;
    run<TResult>(action: () => TResult | Promise<TResult>): Promise<TResult | undefined>;
}

export function createAsyncActionLock(): AsyncActionLock {
    let isInFlight = false;

    return {
        get isInFlight() {
            return isInFlight;
        },
        async run<TResult>(action: () => TResult | Promise<TResult>): Promise<TResult | undefined> {
            if (isInFlight) {
                return undefined;
            }

            isInFlight = true;
            try {
                return await action();
            } finally {
                isInFlight = false;
            }
        },
    };
}
